import { memo, useCallback, useState } from "react";
import Name from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Name/Name";
import Actions from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Actions/Actions";
import FixaCheckbox from "@coworker/apprestructured/src/shared/wrappers/FixaCheckbox/FixaCheckbox";
import Highlight from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Highlight/Highlight";
import Demo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Demo/Demo";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import AddLocation from "@coworker/apprestructured/src/task-management/components/AddLocation/AddLocation";

function AddLocationDemo() {
  const [disabled, setDisabled] = useState(false);
  const [slid, setSlid] = useState("");

  const itemNo = "70466811";

  const handleConfirmClick = useCallback((newSlid: string) => {
    setSlid(newSlid);
  }, []);

  return (
    <Demo>
      <Name>AddLocation</Name>
      <Highlight>
        <FixaListView id="addlocationdemo" size="small">
          <AddLocation
            itemNo={itemNo}
            slid={slid}
            disabled={disabled}
            onConfirmClick={handleConfirmClick}
          />
        </FixaListView>
      </Highlight>
      <Actions>
        <FixaCheckbox
          label="disabled"
          value="addlocationdemo-disabled"
          id="addlocationdemo-disabled"
          checked={disabled}
          onChange={() => setDisabled((prev) => !prev)}
        />
      </Actions>
    </Demo>
  );
}

export default memo(AddLocationDemo);
